import React, { useState } from "react";
import PT from "prop-types";
import * as S from "./index-styled";
import Animated from "_c/Animated";
import { useForm, FormContext } from "react-hook-form";
import { TextField } from "_c/form/Field";
import ButtonGroup from "_c/form/ButtonGroup";
import CameraIcon from "_c/icon/Camera";
import PlaneIcon from "_c/icon/Plane";
import DenyIcon from "_c/icon/Deny";
import { useCloudinaryWidget } from "@/hooks/useCloudinaryWidget";
import { generateUrl } from "@/utils/cloudinary";
import { CircleButton } from '_c/button';

const ResponseForm = ({
  className,
  isOpen,
  photo: initialPhoto,
  text,
  onClose,
  t,
  ...props
}) => {
  const [photo, setPhoto] = useState(initialPhoto);
  const { uploadPhoto } = useCloudinaryWidget();
  const onSubmit = (form) => {
    props.onSubmit({
      ...form,
      photo,
    });
  };
  const methods = useForm({
    defaultValues: {
      text,
    },
  });
  const { handleSubmit } = methods;
  const onPhotoUpload = async () => {
    const photo = await uploadPhoto();
    if (photo) {
      setPhoto(photo);
    }
  };
  const onPhotoRemove = () => {
    setPhoto("");
  };
  return (
    <S.Wrap as="form" onSubmit={handleSubmit(onSubmit)} className={className}>
      <FormContext {...methods}>
        <TextField
          label={t("common:comment")}
          name="text"
          t={t}
          id="comment-text"
          as="textarea"
          required
          rows="5"
        />
        {photo && <S.Thumb src={generateUrl(photo)} />}
        <ButtonGroup style={{ display: "flex", flexWrap: "wrap" }}>
          <CircleButton greenish large type="submit">
            <PlaneIcon width="20" color="white" />
          </CircleButton>
          {props.allowPhoto && (
            <CircleButton
              onClick={photo ? onPhotoRemove : onPhotoUpload}
              type="button"
              large
              medium
              primary={Boolean(!photo)}
              negative={Boolean(photo)}
            >
              <CameraIcon color="white" />
            </CircleButton>
          )}
          <CircleButton type="button" negative large onClick={onClose}>
            <DenyIcon color="white" />
          </CircleButton>
        </ButtonGroup>
      </FormContext>
    </S.Wrap>
  );
};
ResponseForm.propTypes = {
  isOpen: PT.bool,
  allowPhoto: PT.bool,
  photo: PT.string,
  text: PT.string,

  onClose: PT.func.isRequired,
  onSubmit: PT.func.isRequired,
  t: PT.func.isRequired,
};
const ResponseFormAnimated = (props) => {
  return (
    <Animated visible={props.isOpen}>
      <ResponseForm {...props} />
    </Animated>
  );
};

export default ResponseFormAnimated;
